import type { DeepReadonly, InjectionKey, Ref, ShallowRef } from "vue";

import type { Page } from "@/types/Cvd.ts";

export const LayoutSymbol = Symbol("Layout") as InjectionKey<ShallowRef>;

export const SinglePageClass = Symbol("SinglePageClass") as InjectionKey<
  "span-full" | "span-content" | "span-popout"
>;

export const CvdPageData = Symbol("CvdPageData") as InjectionKey<
  DeepReadonly<Ref<Page | null>>
>;
